var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { DropdownButton } from './DropdownButton';
import { Align } from '../util/getRelativePosition';
import { IconButton } from './IconButton';
import { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
export var OverflowMenu = function (_a) {
    var children = _a.children;
    return (jsx(DropdownButton, { align: Align.End, as: OverflowMenuButton }, children));
};
export var OverflowMenuButton = forwardRef(function (_a, ref) {
    var props = __rest(_a, []);
    return (jsx(IconButton, __assign({}, props, { ref: ref, title: "More options", variant: "secondary", sx: { p: 2 } }),
        jsx(FontAwesomeIcon, { icon: faEllipsisH })));
});
//# sourceMappingURL=OverflowMenu.js.map